import SpinReelTransition from "slotworks/components/matrix/reel/transition-behaviours/spin/spin-reel-transition";
import SmartUIFlags, { SmartUIFlag } from "slotworks/smart-ui/smart-ui-flags";
import StateMachine from "slotworks/state-machine/state-machine";

export function DisableSkippingCommand() {
    SpinReelTransition.allowSkips = false;

    StateMachine.onStateEnter.add((stateName: string) => {
        if (stateName.indexOf("request-spin") > -1) {
            SmartUIFlags.set(SmartUIFlag.NO_SKIP, true);
        }
    });
}
